import { useState } from "react"

export interface imgErrorItem {
  index: number,
  src: string
}

interface ImagesContentProps {
  fallbackSrc: string 
}

const useImagesContent = (props: ImagesContentProps) => {
  const { fallbackSrc } = props

  // track which images failed to load
  const [erroredImages, setErroredImages] = useState<Array<imgErrorItem>>([])

  // optional function to handle fallback
  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>, index: number, src: string) => {
    setErroredImages(prev => [...prev, {
      index,
      src
    }])
    if (fallbackSrc) {
      event.currentTarget.src = fallbackSrc
    } else {
      event.currentTarget.style.display = 'none' // hide the broken image
    }
  }

  return {
    erroredImages,
    handleError
  }

}

export default useImagesContent